// extracted by mini-css-extract-plugin
export default {"matchingCriteriaPanel":"matching-criteria-panel_matchingCriteriaPanel__Wb5KC"};